import { lazy, Suspense } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { SUBSIDIARY_CODE } from '@/config';

const GopLanding = lazy(() => import('@/pages/landing/gop'));
const NonPartisanLanding = lazy(() => import('@/pages/landing/nonpartisan'));
const DemocratLanding = lazy(() => import('@/pages/landing/democrat'));

const landingPages = {
  gop: GopLanding,
  nonpartisan: NonPartisanLanding,
  democrat: DemocratLanding,
} as const;

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    // Logged-in users skip to app
    if (context.auth.user) {
      throw redirect({ to: '/app' });
    }
  },
  component: LandingRoute,
});

function LandingRoute() {
  const LandingPage =
    landingPages[SUBSIDIARY_CODE as keyof typeof landingPages] ||
    landingPages.nonpartisan;

  return (
    <Suspense fallback={null}>
      <LandingPage />
    </Suspense>
  );
}
